import { deleteRequest, getRequest, postRequest, putRequest, getFileRequestWithToken } from "../../apiClient";
import { InstanceManagementEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetInstances = async (queryString: any) => {
    var _url = InstanceManagementEndpoint.INSTANCE_MANAGEMENT_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetInstanceById = async (id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_MANAGEMENT_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};

export const GetSummaryInstances = async (queryString: any) => {
    var _url = InstanceManagementEndpoint.INSTANCE_SUMMARY_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetInstanceStoredProcedures = async (queryString: any, id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_STORED_PROCEDURES_BY_ID_URL(id) + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetInstanceAutoBackUps = async (queryString: any, id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_AUTO_BACKUP_BY_ID_URL(id) + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetBackupConfigById = async (id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_BACK_UP_CONFIG_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};

export const GetInstanceDBInstances = async (queryString: any, id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_DATABASE_INSTANCES_BY_ID_URL(id) + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetInstanceActivityLogs = async (queryString: any, id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_ACTIVITY_LOGS_BY_ID_URL(id) + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const DownloadInstanceBackupById = async (id: string | number, historyId: string | number, isZipFile: boolean = false) => {
    var _url = InstanceManagementEndpoint.INSTANCE_DOWNLOAD_BACK_UP_BY_ID_URL(id, historyId) + (isZipFile ? '?zip=true' : '');
    var res = await getFileRequestWithToken(_url);

    return res;
};

export const DBCloneCheckById = async (id: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_DB_CLONE_CHECK_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const InstanceRefreshAllService = async () => {
    var res = await postRequest(InstanceManagementEndpoint.INSTANCE_REFRESH_ALL_URL);

    return res;
};

export const InstanceRefreshByIdService = async (id: string | number) => {
    var res = await postRequest(InstanceManagementEndpoint.INSTANCE_REFRESH_BY_ID_URL(id));

    return res;
};

export const InstanceBackUpNowByIdService = async (id: string | number) => {
    var res = await postRequest(InstanceManagementEndpoint.INSTANCE_BACKUP_NOW_BY_ID_URL(id));

    return res;
};

export const InstanceSchemaCheckByIdService = async (id: string | number) => {
    var res = await postRequest(InstanceManagementEndpoint.INSTANCE_SCHEMA_CHECK_BY_ID_URL(id));

    return res;
};

export const RestoreInstanceBackupById = async (id: string | number, historyId: string | number) => {
    var _url = InstanceManagementEndpoint.INSTANCE_RESTORE_BACK_UP_BY_ID_URL(id, historyId);
    var res = await postRequest(_url);

    return res;
};

export const DbCloneById = async (id: string | number, param: any) => {
    var res = await postRequest(InstanceManagementEndpoint.INSTANCE_DATABASE_INSTANCES_BY_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditBackupConfigService = async (id: string | number, param: any) => {
    var res = await putRequest(InstanceManagementEndpoint.INSTANCE_BACK_UP_CONFIG_BY_ID_URL(id), param);

    return res;
};
// //#endregion

//#region----------------- DELETE-----------------------
export const DeleteDBInstanceById = async (id: string | number, cloneId: string | number, remarks?: any) => {
    var _url = InstanceManagementEndpoint.DELETE_INSTANCE_DATABASE_INSTANCES_BY_ID_URL(id, cloneId);
    var res = await deleteRequest(_url);

    return res;
};
//#endregion